import { useMutation } from '@apollo/client';

import useToast from 'components/ToastProvider/useToast';
import logger from 'helpers/logger';

import { ActivationOnboardingProgressDocument } from '../useActivationOnboardingProgress/ActivationOnboardingProgress.gql';
import useCompanyContext from '../useCompanyContext';
import useMainBankAccountId from '../useMainBankAccountId';
import locales from './locales';
import { SetActivationOnboardingCompleteDocument } from './SetActivationOnboardingCompleted.gql';

const useSetActivationOnboardingCompleted = () => {
  const { companyProfileId, companyUserId } = useCompanyContext();
  const { loading: bankAccountIdLoading, mainBankAccountId } =
    useMainBankAccountId();

  const { showToast } = useToast();

  if (!mainBankAccountId && !bankAccountIdLoading) {
    logger.error(
      'mainBankAccountId is undefined in useSetActivationOnboardingCompleted',
    );

    showToast({ message: locales.error, type: 'error' });
  }

  if (!companyUserId) {
    logger.error(
      'companyUserId is undefined in useSetActivationOnboardingCompleted',
    );

    showToast({ message: locales.error, type: 'error' });
  }

  if (!companyProfileId) {
    logger.error(
      'companyProfileId is undefined in useSetActivationOnboardingCompleted',
    );

    showToast({ message: locales.error, type: 'error' });
  }

  return useMutation(SetActivationOnboardingCompleteDocument, {
    refetchQueries: [
      {
        query: ActivationOnboardingProgressDocument,
        variables: {
          bankAccountId: mainBankAccountId || '',
          companyUserId: companyUserId || '',
        },
      },
    ],
    variables: {
      input: {
        companyProfileId: companyProfileId ?? '',
      },
    },
  });
};

export default useSetActivationOnboardingCompleted;
